<template>
  <d-container fluid class="px-4 main-content-container">
    <!-- Page Header -->
    <d-row no-gutters class="py-4 page-header">
      <d-col col class="mb-4 text-center text-sm-left mb-sm-0" cols="12">
        <span class="text-uppercase page-subtitle d-block">Orçamentos</span>
        <h3 class="page-title d-inline">Editar</h3>
        <d-link class="float-right text-white btn btn-success " href="/admin/orcamentos/novo">Novo orçamento</d-link>
        <d-button type="button" @click.prevent="save" class="float-right mr-2 btn-accent">Salvar</d-button>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <d-card class="mb-4 card-small">
          <!-- Card Header -->
          <d-card-header class="border-bottom">
            <d-row class="align-items-center">
              <d-col cols="12" lg="4">
                <h6 class="m-0">Dados cadastrais</h6>
              </d-col>
              <d-col cols="12" lg="8" class="text-right" v-if="quotation">
                <quotation-buttons :quotation="quotation"></quotation-buttons>
              </d-col>
            </d-row>
          </d-card-header>

          <quotation-form ref="quotationForm"/>
        </d-card>
      </d-col>
    </d-row>
    <import-modals/>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ImportModals from '_modules/quotation/components/ImportModals.vue';
import QuotationForm from '_modules/quotation/components/QuotationForm.vue';
import QuotationButtons from '_modules/quotation/components/QuotationButtons.vue';
import { MODEL, _LOAD_MODEL_, SPECIAL_TYPE_ROW, ROW } from '_modules/quotation/components/QuotationModel';

export default {
  name: 'quotation-edit',
  components: {
    ImportModals,
    QuotationForm,
    QuotationButtons,
  },
  computed: {
    quotation() {
      const { quotation } = this.$store.state.quotation;
      if (quotation) {
        if (quotation.costs && quotation.costs.length === 0) {
          quotation.costs.push({ ...SPECIAL_TYPE_ROW });
        }
        if (quotation.rows.length === 0) {
          quotation.rows.push({ ...ROW });
        }
        Events.$emit(_LOAD_MODEL_, quotation);
        return quotation;
      }
      return MODEL;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getQuotation',
    ]),
    getQuotationModel() {
      this.setToggle({ type: 'progress', bool: true });
      this.getQuotation(parseInt(this.$route.params.quotationId, Number))
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    save() {
      this.$refs.quotationForm.save();
    },
  },
  mounted() {
    if (this.$route.params.quotationId) {
      this.getQuotationModel();
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
